export function loginUsecaseFactory(deps) {
    return (options) => {
        if (options?.target === 'SMAG') {
            return deps.authRepository.doSmagLogin();
        }
        if (options?.target === 'EXTRANET') {
            return deps.authRepository.doExtranetLogin();
        }
        return deps.authRepository.doLogin();
    };
}
//# sourceMappingURL=login.usecase.js.map